<template>
  <div class="main-content-comments">
    <div class="container mt-5 mt-md-0">
      <div class="row">
        <div class="col-12">
          <div class="documents-single" v-if="documentData">
            <div class="documents-single-header">
              <div
                class="documents-shared-right"
                v-if="documentData.user && userId == documentData.user.id"
              >
                <!--                                <like-button class="right:40px"-->
                <!--                                             :docId="documentData.id" v-if="documentData.id" :viewMode="'doc-view'"></like-button>-->
                <div
                  class="team-switch"
                  v-if="userData.team_id && documentData.team_id"
                >
                  <span class="btn shared-btn">TEAM</span>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      @click="teamShareDoc($event)"
                      :checked="documentData.team_shared"
                      id="team-shared"
                    />
                    <label
                      class="custom-control-label"
                      for="team-shared"
                    ></label>
                  </div>
                </div>
                <div class="share-switch">
                  <span class="btn shared-btn" v-if="documentData.shared"
                    >SHARED</span
                  >
                  <span class="btn private-btn" v-else>PRIVATE</span>
                  <div
                    class="custom-control custom-switch"
                    v-if="openAccessPlan"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="shared"
                      :disabled="!share_permissions && !userData.team_id"
                      @click="shareDoc($event)"
                      :checked="documentData.shared"
                    />
                    <label class="custom-control-label" for="shared"></label>
                  </div>
                </div>
              </div>

              <div class="documents-shared-right" v-else>
                <a href="javascript:;" @click="cloneDoc()" class="clone-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <g>
                      <g>
                        <path
                          d="M6.23 14.308a2.538 2.538 0 0 1-2.538-2.539V5.077H2.407c-.565 0-1.022.457-1.022 1.022v8.44c0 1.147.93 2.076 2.077 2.076h8.44c.564 0 1.021-.457 1.021-1.022v-1.285zM6.23 0h9.232A2.538 2.538 0 0 1 18 2.538v9.231a2.538 2.538 0 0 1-2.538 2.539h-1.154v1.285A2.407 2.407 0 0 1 11.9 18h-8.44A3.462 3.462 0 0 1 0 14.538v-8.44a2.407 2.407 0 0 1 2.407-2.406h1.285V2.538A2.538 2.538 0 0 1 6.231 0zm0 1.385c-.636 0-1.153.516-1.153 1.153v9.231c0 .637.517 1.154 1.154 1.154h9.23c.638 0 1.154-.517 1.154-1.154V2.54c0-.638-.516-1.154-1.153-1.154z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </a>
                <like-button
                  :t35="true"
                  :docId="documentData.id"
                  v-if="documentData.id"
                  :viewMode="'doc-view'"
                ></like-button>
              </div>
              <div class="documents-title">
                <h5>
                  <img
                    src="/assets/img/picture-icon.svg"
                    alt=""
                    v-if="documentData.entity_group == 'Colour Theme'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="documentData.entity_group == 'Planner'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="documentData.entity_group == 'Priorities Matrix'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="documentData.entity_group == 'Portfolio'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="documentData.entity_group == 'PowerBITheme'"
                  />
                  <img
                    src="/assets/img/playlist_small_play.svg"
                    height="12"
                    alt=""
                    v-else-if="documentData.entity_group == 'Playlist'"
                  />
                  <img src="/assets/img/file-icon.svg" alt="" v-else />
                  <span
                    :class="{
                      'text-uppercase': documentData.entity_group === 'Dax',
                    }"
                    >{{ documentData.entity_group }}</span
                  >
                  <span class="date">{{
                    documentData.created_at | moment("D MMMM YYYY")
                  }}</span>
                </h5>
                <h1
                  @click="editNameDesc()"
                  :class="{ 'edit-title': share_permissions }"
                >
                  {{ documentData.name }}
                </h1>

                <div class="profile-author" v-if="documentData.user">
                  <div class="user-img">
                    <avatar
                      :src="'/storage/' + documentData.user.photo"
                      :username="documentData.user.name"
                      v-if="documentData.user && documentData.user.name"
                      :size="44"
                    ></avatar>
                  </div>
                  <h6>
                    {{ documentData.user.name
                    }}<small v-if="share_permissions"
                      ><a @click="editNameDesc" class="edit-comment-link"
                        >(Edit)</a
                      ></small
                    >
                  </h6>
                </div>
                <div class="documents-description">
                  <p v-html="documentData.description" class="tinymce-html"></p>
                  <p class="project-link" v-if="documentData.entity_data.link">
                    Project Link:
                    <a :href="documentData.entity_data.link" target="_blank">{{
                      documentData.entity_data.link
                    }}</a>
                  </p>
                </div>
              </div>
              <a
                href="https://forum.enterprisedna.co/"
                class="button"
                target="_blank"
                rel="noopener noreferrer"
                >Discuss On Forum</a
              >
            </div>
            <ViewPictures
              :pictures="documentData.entity_data.pictures"
              v-if="documentData.entity_data.pictures"
            />

            <comments
              :docId="documentData.id"
              v-if="documentData.id"
              :likes_count="totalLikes"
              class="mb-5"
            ></comments>
          </div>
        </div>
      </div>
    </div>

    <doc-edit-name v-if="editTitle && documentData"></doc-edit-name>
  </div>
</template>

<script>
import DocumentHttpService from "../services/DocumentHttpService";
import Avatar from "vue-avatar";
import Comments from "./Comments";
import ApiService from "../api/api.service";
import LikeButton from "./partials/LikeButton";
import VerticalColourPalette from "./partials/VerticalColourPalette";
import ViewPictures from "./ViewPictures";
import DocEditName from "./DocEditName";

export default {
  name: "DocumentView",
  components: {
    DocEditName,
    VerticalColourPalette,
    LikeButton,
    Avatar,
    Comments,
    ViewPictures,
  },
  data: () => {
    return {
      docService: new DocumentHttpService(),
      documentData: null,
      share_permissions: false,

      userId: null,
      userData: null,
      likeStatus: false,
      totalLikes: 0,
      unauthorised: false,

      openAccessPlan: false,

      editTitle: false,
      title_updated: false,
    };
  },
  mounted() {
    let id = this.$route.query.id || this.$route.params.doc_id;
    if (id) {
      setTimeout(() => {
        this.setCurrentUser();
        this.loadDoc(id);
      }, 400);
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && to.params.doc_id != from.params.doc_id) {
        let id = this.$route.query.id || this.$route.params.doc_id;
        if (id) {
          setTimeout(() => {
            this.setCurrentUser();
            this.loadDoc(id);
          }, 400);
        }
      }
    },
  },
  methods: {
    loadDoc(id) {
      this.docService.get(id).then(
        (res) => {
          this.documentData = res.data.doc;
          if (this.documentData) {
            const titleEl = document.querySelector("head title");
            titleEl.textContent =
              this.documentData.name + " - Analyst Hub by Enterprise DNA";

            // check share permissions
            this.share_permissions =
              this.documentData.user &&
              this.userId == this.documentData.user.id &&
              !this.documentData.team_shared;
            this.documentData.entity_data = res.data.entity;

            this.openAccessPlan =
              !this.userData.free_plan || res.data.doc.latest_three;

            this.likedByMe();
          } else {
            this.unauthorised = true;
          }
        },
        function (res) {
          console.error(res);
        }
      );
    },

    setCurrentUser() {
      // check share permissions
      this.userData = JSON.parse(localStorage.getItem("user"));
      this.userId = this.userData.id;
    },
    shareDoc($event) {
      ApiService.setHeader();
      ApiService.put("api/document/share/" + this.documentData.id, {
        shared: $event.target.checked,
      })
        .then(({ data }) => {
          this.documentData.shared = $event.target.checked;
          if (this.documentData.shared) {
            this.documentData.team_shared = false;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    teamShareDoc($event) {
      ApiService.setHeader();
      ApiService.put("api/document/share/" + this.documentData.id, {
        team_shared: $event.target.checked,
      })
        .then(({ data }) => {
          this.documentData.team_shared = $event.target.checked;
          if (this.documentData.team_shared) {
            this.documentData.shared = false;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    likedByMe() {
      ApiService.setHeader();
      ApiService.get("api/document/liked/" + this.documentData.id)
        .then(({ data }) => {
          this.likeStatus = data.data;
          this.totalLikes = data.total;
        })
        .catch((res) => {
          console.log(res);
        });
    },

    updateTitle() {
      let params = {
        name: this.documentData.name,
        description: this.documentData.description,
        team_shared: this.documentData.team_shared,
        shared: this.documentData.shared,
      };
      ApiService.setHeader();
      ApiService.put("api/document/rename/" + this.documentData.id, params)
        .then(({ data }) => {
          this.title_updated = true;
          setTimeout(() => {
            this.editTitle = false;
            this.title_updated = false;
          }, 2000);
        })
        .catch((res) => {
          console.log(res);
        });
    },

    editNameDesc() {
      if (this.documentData.user && this.userId == this.documentData.user.id) {
        this.editTitle = true;
      }
    },

    closePopup() {
      let id = this.$route.query.id || this.$route.params.doc_id;
      if (id) {
        this.loadDoc(id);
      }
      this.editTitle = false;
    },

    cloneDoc() {
      // this.$router.push({query: { clone: 'true' }})
      // window.location.replace(this.$route.fullPath + '&clone=true');
      const query = Object.assign({}, this.$route.query);
      query.clone = true;
      this.$router.push({ query });
      window.location.replace(this.$route.fullPath);

      localStorage.setItem("clone_from", "doc");
    },
  },
};
</script>

<style scoped>
.main-content-comments {
  box-shadow: 0px -10px 10px -10px rgba(0, 0, 0, 0.2);
  margin: 5px -60px auto -60px;
}

.main-content-comments .container {
  margin-bottom: -100px;
  width: calc(100% - 80px);
}

.btn.shared-btn,
.btn.private-btn {
  border-radius: 10px;
}

@media (min-width: 320px) and (max-width: 474px) {
  .main-content-comments .container {
    max-width: 75%;
    margin: auto;
    display: table;
  }
  .documents-shared-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0 15px;
  }
  .documents-shared-right .custom-switch {
    margin-left: 20px;
  }

  .documents-shared-right .team-switch .custom-control {
    margin: auto;
  }
  .documents-shared-right .share-switch .custom-control {
    margin: auto;
  }

  .documents-shared-right .team-switch {
    margin-right: 20px;
  }
}

@media (min-width: 475px) and (max-width: 576px) {
  .main-content-comments .container {
    max-width: 80%;
    margin: auto;
    display: table;
  }
  .documents-shared-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0 15px;
  }
  .documents-shared-right .custom-switch {
    margin-left: 20px;
  }

  .documents-shared-right .team-switch .custom-control {
    margin: auto;
  }
  .documents-shared-right .share-switch .custom-control {
    margin: auto;
  }

  .documents-shared-right .team-switch {
    margin-right: 20px;
  }
}
@media (min-width: 576px) {
  .main-content-comments .container {
    max-width: 540px;
    margin: auto;
  }

  .documents-shared-right {
    width: 190px;
  }

  .documents-shared-right .team-switch {
    float: left;
  }
  .documents-shared-right .share-switch {
    float: right;
  }

  .documents-shared-right .team-switch {
    margin-right: 20px;
  }
}

@media screen and (min-width: 1200px) {
  .main-content-comments .container {
    max-width: 1024px;
  }
}
@media screen and (min-width: 1600px) {
  .main-content-comments .container {
    max-width: 1225px;
  }
}

.documents-shared-right a.clone-link {
  width: 48px;
  height: 48px;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 35px;
  right: 60px;
}

.button {
  background-color: #008cba;
  border: none;
  border-radius: 20px;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.2);
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.documents-shared-right {
  margin-top: 0px;
}
</style>
